import React from "react";
import "./About.scss";
import InnerHeader from "../../component/shared/innerheader/InnerHeader.js";
import { useIntl } from "react-intl";
import { Link, Outlet } from "react-router-dom";

function About() {

  const intl = useIntl();

  const [toggleState, setToggleState] = React.useState( window?.location?.pathname?.includes("/vision-mission") ? 1 :
  window?.location?.pathname?.includes("chairman-word") ? 2 :
  window?.location?.pathname?.includes("organizaitional-structure") ? 3 :
  window?.location?.pathname?.includes("device-history") ? 4 :
  window?.location?.pathname?.includes("laws-frameworks") ? 5 : 1)

  const [title, setTitle] = React.useState( window?.location?.pathname?.includes("/vision-mission") ? "vision-mission" :
    window?.location?.pathname?.includes("chairman-word") ? "chairman-word" :
    window?.location?.pathname?.includes("organizaitional-structure") ? "organizaitional-structure" :
    window?.location?.pathname?.includes("device-history") ? "device-history" :
    window?.location?.pathname?.includes("laws-frameworks") ?  "laws-frameworks" : "vision-mission")

  const toggleTap = (index, title) => {
    setToggleState(index);
    setTitle(title);
  };

  React.useEffect(() => {
    const timeOut = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
    return () => {
      clearTimeout(timeOut)
    }
  }, [])


  return (
    <div className="About">
      <InnerHeader
        breadcrumb={[
          {
            title: intl.formatMessage({ id: "about" }),
            clickClass: false,
          },
          {
            title: intl.formatMessage({ id: title }),
            clickClass: true,
          },
        ]}
        title={intl.formatMessage({ id: "about-title" })}
      />
      <div className="sub-tab">
        <div className="container">
          <ul>
            <li>
              <Link to={"/about/vision-mission"}>
                <span
                  onClick={() => toggleTap(1, "vision-mission")} 
                  className={toggleState === 1 ? "active" : ""}
                >
                  {intl.formatMessage({ id: "vision-mission"})}
                </span>
              </Link>
            </li>
            <li>
              <Link to={"/about/chairman-word"}>
                <span
                  onClick={() => toggleTap(2, "chairman-word")}
                  className={toggleState === 2 ? "active" : ""}
                >
                  {intl.formatMessage({ id: "chairman-word"})}
                </span>
              </Link>
            </li>
            <li>
              <Link to={"/about/organizaitional-structure"}>
                <span
                  onClick={() => toggleTap(3, "organizaitional-structure")}
                  className={toggleState === 3 ? "active" : ""}
                >
                  {intl.formatMessage({ id: "organizaitional-structure"})}
                </span>
              </Link>
            </li>
            <li>
              <Link to={"/about/device-history"}>
                <span
                  onClick={() => toggleTap(4, "device-history")}
                  className={toggleState === 4 ? "active" : ""}
                >
                  {intl.formatMessage({ id: "device-history"})}
                </span>
              </Link>
            </li>
            <li>
              <Link to={"/about/laws-frameworks"}>
                <span
                  onClick={() => toggleTap(5, "laws-frameworks")}
                  className={toggleState === 5 ? "active" : ""}
                >
                  {intl.formatMessage({ id: "laws-frameworks"})}
                </span>
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="container mb-4">
        <div className="tab-body pt-4">
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default About;
